const initialState = {
	isLoading: false,
	loginChecked: {
		admin: false,
		reviewer: false
	},
	admin: null,
	reviewer: null,
	loginTokenLoading: false,
	loginTokens: {},
	loginTypeAttempted: null,
	errors: {},
	loginAttempts: {},
	maxLoginsReached: {},
	passwordRequestSuccess: false,
	passwordRequestErrors: {},
	changePasswordSuccess: false,
	changePasswordErrors: {},
	passwordUpdateSuccess: false,
	passwordUpdateErrors: {},
	accountCreateSuccess: false,
	accountUpdateSuccess: false
};

const userTypeMap = {
	reviewer: "reviewer",
	admin: "user"
};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//  LOGIN TOKEN
		// ===================================
		case "USER_LOGIN_TOKEN_LOADING":
			return { ...state, loginTokenLoading: true };

		case "USER_LOGIN_TOKEN_SET":
			return {
				...state,
				loginTokenLoading: false,
				loginTokens: { ...state.loginTokens, [action.userType]: action.token },
				maxLoginsReached: {
					...state.maxLoginsReached,
					[action.userType]: action.maxLoginsReached
				}
			};

		case "UPDATE_USER_MAX_LOGIN":
			return {
				...state,
				maxLoginsReached: {
					...state.maxLoginsReached,
					[action.userType]: action.maxLoginsReached
				}
			};

		// ===================================
		//  LOGIN
		// ===================================
		case "USER_LOGIN_LOADING":
			return { ...state, isLoading: true, errors: {}, loginTypeAttempted: action.userType };

		case "USER_LOGIN_ERROR":
			return { ...state, errors: action.err, isLoading: false };

		case "USER_LOGIN_SUCCESS":
			// Get token
			const { token } = action.payload;

			// Get any user data sent back from api
			const userData = action.payload[userTypeMap[action.userType]];

			const guest = action.userType === "admin" ? state.guest : initialState.guest;
			const reviewer = action.userType === "admin" ? state.reviewer : initialState.reviewer;

			const newState = {
				...state,
				isLoading: false,
				guest,
				reviewer,
				[action.userType]: {
					// User data will be updated if supplied
					user: !userData ? { ...state[action.userType].user } : { ...userData },
					token: token
				},
				loginTokens: { ...state.loginTokens, [action.userType]: "" },
				maxLoginsReached: { ...state.maxLoginsReached, [action.userType]: false },
				errors: {}
			};

			return newState;

		case "USER_LOGOUT":
			return { ...state, loginTypeAttempted: null, [action.userType]: null };

		case "CLEAR_ERRORS":
			return { ...state, loginTypeAttempted: null, errors: {} };

		case "EXPIRY_CHECKED":
			return { ...state, loginChecked: { ...state.loginChecked, [action.userType]: true } };

		case "USER_TOKEN_UPDATE":
			return {
				...state,
				[action.userType]: { ...state[action.userType], token: action.token }
			};

		// ===================================
		//  PASSWORD REQUEST
		// ===================================
		case "PASSWORD_REQUEST_LOADING":
			return {
				...state,
				passwordRequestSuccess: initialState.passwordRequestSuccess,
				passwordRequestErrors: initialState.passwordRequestErrors,
				isLoading: true
			};

		case "PASSWORD_REQUEST_ERROR":
			return { ...state, passwordRequestErrors: action.err, isLoading: false };

		case "PASSWORD_REQUEST_SUCCESS":
			return { ...state, passwordRequestSuccess: true, isLoading: false };

		// ===================================
		//  CHANGE PASSWORD
		// ===================================
		case "CHANGE_PASSWORD_LOADING":
			return {
				...state,
				changePasswordSuccess: initialState.changePasswordSuccess,
				changePasswordErrors: initialState.changePasswordErrors,
				isLoading: true
			};

		case "CHANGE_PASSWORD_ERROR":
			return { ...state, changePasswordErrors: action.err, isLoading: false };

		case "CHANGE_PASSWORD_SUCCESS":
			return { ...state, changePasswordSuccess: true, isLoading: false };

		case "RESET_CHANGE_PASSWORD_SUCCESS":
			return {
				...state,
				changePasswordSuccess: false
			};

		// ===================================
		//  PASSWORD REQUESTe
		// ===================================
		case "CREATE_ACCOUNT_LOADING":
			return {
				...state,
				accountCreateSuccess: initialState.accountCreateSuccess,
				accountUpdateSuccess: initialState.accountUpdateSuccess,
				errors: initialState.errors,
				isLoading: true
			};

		case "CREATE_ACCOUNT_ERROR":
			return { ...state, errors: action.err, isLoading: false };

		case "CREATE_ACCOUNT_SUCCESS":
			return { ...state, accountCreateSuccess: true, isLoading: false };

		// ===================================
		//  PASSWORD UPDATE
		// ===================================
		case "PASSWORD_UPDATE_LOADING":
			return {
				...state,
				passwordUpdateSuccess: initialState.passwordUpdateSuccess,
				passwordUpdateErrors: initialState.passwordUpdateErrors,
				isLoading: true
			};

		case "PASSWORD_UPDATE_ERROR":
			return { ...state, passwordUpdateErrors: action.err, isLoading: false };

		case "PASSWORD_UPDATE_SUCCESS":
			return { ...state, passwordUpdateSuccess: true, isLoading: false };

		case "PASSWORD_UPDATE_CLEAR_ERRORS":
			return { ...state, passwordUpdateErrors: initialState.passwordUpdateErrors };

		// ===================================
		//  UPDATE ACCOUNT
		// ===================================
		case "UPDATE_REVIEWER_ACCOUNT_SUCCESS":
			// console.log("UPDATE_REVIEWER_ACCOUNT_SUCCESS", action.reviewer);

			return {
				...state,
				reviewer: { ...state.reviewer, user: action.reviewer },
				accountUpdateSuccess: true,
				isLoading: false
			};

		case "RESET_UPDATE_ACCOUNT_SUCCESS":
			return {
				...state,
				accountUpdateSuccess: false
			};

		// ===================================
		//	REGISTRATION
		// ===================================
		case "REGISTRATIONS_SET":
			return {
				...state,
				reviewer: {
					...state.reviewer,
					user: { ...state.reviewer.user, registrations: action.data.data.registrations }
				}
			};

		// ===================================
		//  UPDATE ACTIVE REVIEWS
		// ===================================
		case "UPDATE_REVIEWER_REVIEWS_LOADING":
			return {
				...state,
				reviewerReviewsError: null,
				reviewerReviewsLoading: true
			};

		case "UPDATE_REVIEWER_REVIEWS_ERROR":
			return {
				...state,
				reviewerReviewsError: action.err,
				reviewerReviewsLoading: false
			};
		case "UPDATE_REVIEWER_REVIEWS_SUCCESS":
			const reviews = action.data.data.reviews;

			return {
				...state,
				reviewerReviewsLoading: false,
				reviewer: {
					...state.reviewer,
					user: {
						...state.reviewer.user,
						...reviews
					}
				}
			};

		// ===================================
		//  UPDATE TRAINING EDUCATION SIGNUPS
		// ===================================
		case "UPDATE_REVIEWER_TRAINING_EDUCATION_LOADING":
			return {
				...state,
				reviewerTrainingEducationError: null,
				reviewerTrainingEducationLoading: true
			};

		case "UPDATE_REVIEWER_TRAINING_EDUCATION_ERROR":
			return {
				...state,
				reviewerTrainingEducationError: action.err,
				reviewerTrainingEducationLoading: false
			};
		case "UPDATE_REVIEWER_TRAINING_EDUCATION_SUCCESS":
			const training_education_signups = action.data.data.training_education_signups;

			return {
				...state,
				reviewerTrainingEducationLoading: false,
				reviewer: {
					...state.reviewer,
					user: {
						...state.reviewer.user,
						training_education_signups
					}
				}
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/user.js